import React from 'react';
import Button from './Button' 
import logo from '../images/tutorial/logo.png'
import chooseAlgorithmButton from '../images/tutorial/chooseAlgorithmButton.png'
import cenarioGrafo from '../images/tutorial/cenarioGrafo.png'
import cenarioMouse from '../images/tutorial/mouse.png'
import spaceTut from '../images/tutorial/spaceTut.png'
import snowTut from '../images/tutorial/snowTut.png'
import lavaTut from '../images/tutorial/lavaTut.png'

export const Modal = ({ showModal, idCenario }) => {

    const close = () => {
        document.getElementById('popup').setAttribute("style", "display:none");
        document.getElementById('alert2').setAttribute("style", "display:block");
        document.getElementById('alertAlgorithm').setAttribute("style", "display:block");
    }

    const next = (pageId, id) => {
        // Remove current page
        document.getElementById(`${pageId}`).setAttribute("style", "display:none");
        // Show next page
        id = id + 1;
        let nextPage = 'page' + id.toString();
        document.getElementById(`${nextPage}`).setAttribute("style", "display:block");
        //Change header
        changeHeader(id);
    }

    const previous = (pageId, id) => {
        // Remove current page
        document.getElementById(`${pageId}`).setAttribute("style", "display:none");
        // Show previous page
        id = id - 1;
        let previousPage = 'page' + id.toString();
        document.getElementById(`${previousPage}`).setAttribute("style", "display:block");
        //Change header
        changeHeader(id);
    }

    const changeHeader = (id) => {
        let headerText = id === 1 ? "Algorithm Race" : (id === 2 ? "Sceneries" : (id === 3 ? "Sceneries - Spaceship" : (id === 4 ? "Sceneries - Water" : (id === 5 ? "Sceneries - Fire" : (id === 6 ? "Selecting a Starting Point" : (id === 7 ? "Choosing an Algorithm " : (id === 8 || id === 9 ? "Algorithms" : (id === 10 ? "Distances" : "That's it!!"))))))));
        document.getElementById('modalHeader').innerText = headerText;
    }

    return (
        <>
            {showModal &&
                <div id={'popup'} className="modal">
                    <div className="modal-content">
                        <div className="modal-header">
                        <span className="close" onClick={() => close()}>&times;</span>
                        <h2 id={'modalHeader'}>Algorithm Race</h2>
                        </div>
                        {/* Intro */}
                        <div id={'page1'} className="modal-body">
                            <p>This application aims to find the shortest path between two points 
                                and it allows you to visualize the search for the shortest path 
                                using different algorithms.
                            </p>
                            <img src={logo} alt="" height="200"/>
                            <div className="modal-footer"> 
                                <Button 
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page1', 1)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Sceneries */}
                        <div id={'page2'} className="modal-body-2"> 
                            <p>The design of each scenery is defined by an undirected weighted graph, 
                                where the rooms represent the vertices and the connections between them represent the edges.
                            </p>
                            <p>The weight of each edge is a random value - which can be modified - and 
                                it is shown on the edge itself.
                            </p>
                            <img src={cenarioGrafo} alt="" height="150"/>
                            <p>You can click on the button <button2 className='disableModalButton'> Change Scenery </button2> to change the scenery.</p>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page2', 2)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page2', 2)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Sceneries - Spaceship*/}
                        <div id={'page3'} className="modal-body-2"> 
                            <img src={spaceTut} alt="" height="350"/>
                            <p></p>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page3', 3)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page3', 3)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Sceneries - Water*/}
                        <div id={'page4'} className="modal-body-2"> 
                            <img src={snowTut} alt="" height="350"/>
                            <p></p>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page4', 4)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page4', 4)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Sceneries - Fire*/}
                        <div id={'page5'} className="modal-body-2"> 
                            <img src={lavaTut} alt="" height="350"/>
                            <p></p>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page5', 5)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page5', 5)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Selecting a Starting Point*/}
                        <div id={'page6'} className="modal-body-2"> 
                            <p>Each scenery has a character who will search for the shortest 
                                path from the starting room to the final room.
                            </p>
                            <p>The starting point of the character can be chosen by 
                                clicking on the desired room.
                            </p>
                            <br></br>
                            <p></p>
                            <img src={cenarioMouse} alt="" />
                            <p></p>
                            <br></br>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page6', 6)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page6', 6)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Choosing an Algorithm */}
                        <div id={'page7'} className="modal-body-2"> 
                            <p>You can choose the desired algorithm to perform the 
                                search by clicking on the button shown below.
                            </p>
                            {/* <div className="dropdown">
                                <button2  onClick={() => document.getElementById('myDropdown2').classList.toggle("show")} className='ripple2'> Choose Algorithm ▼ </button2>
                                <div id={'myDropdown2'} className="dropdown-content">
                                    <a href='#'>Dijkstra</a>
                                    <a href="#">A* Search</a>
                                    <a href="#">Breadth-First Search</a>
                                    <a href="#">Depth-First Search</a>
                                    <a href="#">Bellman-Ford</a>
                                    <a href="#">Floyd-Warshall</a>
                                </div>
                            </div>*/} {/*className='disableModalButton' */}
                            <img src={chooseAlgorithmButton} alt=""/>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page7', 7)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page7', 7)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Algorithms */}
                        <div id={'page8'} className="modal-body-3"> 
                        <dl>
                            <dt><b>Dijkstra's Algorithm</b></dt>
                            <dd>- Dijkstra's algorithm finds the shortest path from the start node to every node on the graph.</dd>
                            <dd>- It is <em>weighted</em>, so it takes the distances between the nodes into account.</dd>
                            <dd>- It <em>guarantees</em> the shortest path.</dd>

                            <dt><b>A* Search</b></dt>
                            <dd>- A* Search is one of the best algorithms used in path-finding.</dd>
                            <dd>- It achieves better performance compared to Dijkstra's algorithm by using heuristics to guide its search.</dd>
                            <dd>- It is also <em>weighted</em> and <em>guarantees</em> the shortest path.</dd>

                            <dt><b>Breadth-First Search</b></dt>
                            <dd>- Breadth-First Search explores the graph in layers from an initial vertex. For this reason, it is particularly useful for calculating the unweighted distance between vertices.</dd>
                            <dd>- It is <em>unweighted</em>, so it does not take the distances between the nodes into account.</dd>
                            <dd>- It <em>guarantees</em> the shortest path.</dd>
                        </dl>
                        <div className="modal-footer"> 
                            <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page8', 8)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page8', 8)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        <div id={'page9'} className="modal-body-3"> 
                        <dl>
                            <dt><b>Depth-First Search</b></dt>
                            <dd>- Depth-First Search explores a path in the graph as far as possible and then it goes back along the path (backtracking), looking for other routes not yet visited.</dd>
                            <dd>- It is <em>unweighted</em>, so it does not take the distances between the nodes into account.</dd>
                            <dd>- DFS is often preferred if we want to visit every node in the graph. However, if we want to find the shortest path between two nodes, BFS is generally better.</dd>
                            <dd>- It <em>does not</em> guarantee the shortest path.</dd>

                            <dt><b>Bellman-Ford </b></dt>
                            <dd>- Bellman-Ford algorithm finds the <em>minimum weight path</em> from the source to all nodes.</dd>
                            <dd>- Despite being slower than Dijkstra's algorithm, it has an advantage as it deals with negative edges.</dd>

                            <dt><b>Floyd-Warshall</b></dt>
                            <dd>- Floyd-Warshall algorithm finds the <em>shortest path</em> between all pairs of vertices.</dd>
                            <dd>- It is also <em>weighted</em> and allows negative edges.</dd>
                            <dd>- Its advantage over Dijkstra and Bellman-Ford algorithms is that it finds the paths between all pairs of vertices in a single execution.</dd>
                        </dl>
                        <div className="modal-footer"> 
                            <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page9', 9)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page9', 9)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* Distances */}
                        <div id={'page10'} className="modal-body-2"> 
                            <p>You can change the distances between the connections that link each 
                                point on the scenery by clicking on the button shown below.
                            </p>
                            <button2 className='disableModalButton'> Change Distances </button2>
                            <p>Each time you click on the button, all distances change randomly.
                            </p>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page10', 10)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Next' 
                                    onClick={() => {
                                        next('page10', 10)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Skip tutorial' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>
                        {/* That's it!! */}
                        <div id={'page11'} className="modal-body-2"> 
                            <p>After you choose the desired parameters, just click on <button2 className='disableModalButton'> Start </button2> to begin your search.
                            </p>
                            <div className="modal-footer"> 
                                <Button
                                    idCenario={idCenario}
                                    text='Previous' 
                                    onClick={() => {
                                        previous('page11', 11)
                                    }}
                                />
                                ___________
                                <Button
                                    idCenario={idCenario}
                                    text='Close' 
                                    onClick={() => {
                                        close()
                                    }}
                                />
                            </div>
                        </div>

                        {/* <Popup
                                trigger={<button className="button"> Trigger </button>}
                                position="top center"
                                nested
                                >
                                <span>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae
                                magni omnis delectus nemo, maxime molestiae dolorem numquam
                                mollitia, voluptate ea, accusamus excepturi deleniti ratione
                                sapiente! Laudantium, aperiam doloribus. Odit, aut.
                                </span>
                            </Popup> 
                        */}
                    </div>
                </div>
                      
            }
        </>
    )
}

export default Modal